import { useForm } from "react-hook-form";
import FormContainer from "../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { LogTipoTabela } from "../../../../../../common/utils/log_tabela_tipo";
import { ItemChecklistEntrega } from "../../../../domain/models/item_checklist_entrega";
import { ChecklistItemEntregaCadastroForm } from "../../../schemas/checklist_entrega_lista/checklistItemEntregaCadastro";

type props = {
    open: boolean,
    saving: boolean,
    loading: boolean,
    hookFormCadastro: ReturnType<typeof useForm<ChecklistItemEntregaCadastroForm>>,
    selectedItemChecklistEntrega?: ItemChecklistEntrega,
    handleNewItemChecklistEntrega: () => void,
    handleOpenChangeHistory: (idTabela: number | null, tipoTabela: LogTipoTabela | null) => void
    onClose: () => void,
    onSubmit: (form: ChecklistItemEntregaCadastroForm) => void,
}

export const CadastroItemChecklistEntregaModal = ({
    open,
    saving,
    loading,
    selectedItemChecklistEntrega,
    handleNewItemChecklistEntrega,
    handleOpenChangeHistory,
    onClose,
    onSubmit,
    hookFormCadastro,
}: props) => {

    return (
        <BaseFormControlledModal
            open={open}
            saving={saving}
            loading={loading}
            title="Cadastro dos Itens a serem inspecionados no ambiente"
            confirmButtonLabel="Salvar"
            onClose={onClose}
            leftButtonSlot={
                selectedItemChecklistEntrega &&
                <div className="flex flex-row gap-2">
                    <PrimaryButton
                        buttonColor="yellow"
                        onClick={() => handleOpenChangeHistory(selectedItemChecklistEntrega?.idItemChecklistEntrega ?? null, LogTipoTabela.ITEM_CHECKLIST_ENTREGA)}>
                        <span className="text-xs">
                            Historico de alterações
                        </span>
                    </PrimaryButton>
                </div>
            }
            onSubmit={hookFormCadastro.handleSubmit(onSubmit)}>

            <FormContainer title={"Cadastro"} arrangement="fullRow">
                <>
                    <DefaultFormInput
                        name='ordem'
                        label='Ordem'
                        readOnly={false}
                        required={true}
                        reactHookForm={hookFormCadastro}
                    />

                    <DefaultFormInput
                        name={'descricao'}
                        label="Descrição do Item"
                        readOnly={false}
                        required={true}
                        multiline={true}
                        rows={6}
                        minRows={3}
                        maxRows={10}
                        reactHookForm={hookFormCadastro}
                    />
                </>
            </FormContainer>
        </BaseFormControlledModal >
    );
}